import classNames from 'classnames'
import Image from 'next/image'
import { StaticImageData } from 'next/image'

import { config } from '@/components/Ad/Ad'
import OutboundLink from '@/components/OutboundLink/OutboundLink'

import styles from './GatherersTavernAd.module.scss'

type GatherersTavernConfigEntryType = {
  banner: string
  poster: string
}

type GatherersTavernConfigType = {
  [key: string]: GatherersTavernConfigEntryType
}

const gatherersTavernConfig: GatherersTavernConfigType = {
  'betor-ancestors-voice': { banner: 'gatherersTavernBannerBetor', poster: 'gatherersTavernPosterBetor' },
  'betor-kin-to-all': { banner: 'gatherersTavernBannerBetor', poster: 'gatherersTavernPosterBetor' },
  'neriv-crackling-vanguard': { banner: 'gatherersTavernBannerNeriv', poster: 'gatherersTavernPosterNeriv' },
  'neriv-heart-of-the-storm': { banner: 'gatherersTavernBannerNeriv', poster: 'gatherersTavernPosterNeriv' },
  'shiko-and-narset-unified': { banner: 'gatherersTavernBannerShiko', poster: 'gatherersTavernPosterShiko' },
  'shiko-paragon-of-the-way': { banner: 'gatherersTavernBannerShiko', poster: 'gatherersTavernPosterShiko' },
  'teval-arbiter-of-virtue': { banner: 'gatherersTavernBannerTeval', poster: 'gatherersTavernPosterTeval' },
  'teval-the-balanced-scale': { banner: 'gatherersTavernBannerTeval', poster: 'gatherersTavernPosterTeval' },
  'ureni-of-the-unwritten': { banner: 'gatherersTavernBannerUreni', poster: 'gatherersTavernPosterUreni' },
  'ureni-the-song-unending': { banner: 'gatherersTavernBannerUreni', poster: 'gatherersTavernPosterUreni' },
}

const dimensions = {
  banner: { height: 90, width: 728 },
  poster: { height: 225, width: 400 },
}

const findGatherersTavernSlug = (slugs: string[]): keyof typeof gatherersTavernConfig | null =>
  slugs.find((slug) => slug in gatherersTavernConfig) ?? null

type Props = {
  className?: string
  slug: keyof typeof gatherersTavernConfig
  variant: keyof GatherersTavernConfigEntryType
}

const GatherersTavernAd = ({ className, slug, variant }: Props) => {
  const adConfig = gatherersTavernConfig[slug]

  if (!adConfig) return null

  const { alt, src, url } = config[adConfig[variant]]

  return (
    <div className={classNames(styles.container, className, styles[variant])}>
      <OutboundLink url={url as string}>
        <Image
          alt={alt}
          className={styles.image}
          height={dimensions[variant].height}
          src={src as StaticImageData}
          width={dimensions[variant].width}
        />
      </OutboundLink>
    </div>
  )
}

export { findGatherersTavernSlug }
export default GatherersTavernAd
